import type { Module } from 'vuex'
import type { RootState } from '@/store'
import type { AlertsState } from './types'
import { ALERTS_ACTIONS, ALERTS_GETTERS } from './types'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const alerts: Module<AlertsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

export { ALERTS_ACTIONS, ALERTS_GETTERS }
export type { AlertsState }
export default alerts
